import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "text-lg font-semibold" }
const _hoisted_4 = { class: "mt-2 text-gray-600" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "d-flex flex-wrap align-items-center mt-15" }
const _hoisted_14 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_15 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_16 = { class: "custom-search" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-9" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_22 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_23 = { class: "d-sm-flex align-items-center" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_26 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_27 = {
  key: 1,
  class: "text-info"
}
const _hoisted_28 = { key: 2 }
const _hoisted_29 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_30 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.reception.note_ref), 1),
        _createElementVNode("p", _hoisted_4, [
          (_ctx.reception.note_type == 'CSTMR')
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, [
                _cache[9] || (_cache[9] = _createTextVNode(" Date de création : ", -1)),
                (_ctx.reception.created_at)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_6, _toDisplayString(_ctx.getDate(_ctx.reception.created_at)), 1))
                  : _createCommentVNode("", true),
                _cache[10] || (_cache[10] = _createTextVNode(" | Client : ", -1)),
                _createElementVNode("b", null, _toDisplayString(_ctx.reception.note_customer_name), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.reception.note_type == 'GLOBAL')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _cache[11] || (_cache[11] = _createTextVNode(" Date de création : ", -1)),
                (_ctx.reception.created_at)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_8, _toDisplayString(_ctx.getDate(_ctx.reception.created_at)), 1))
                  : _createCommentVNode("", true),
                _cache[12] || (_cache[12] = _createTextVNode(" | ", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("b", null, " GLOBAL ", -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.reception.note_type == 'STOCK')
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _cache[14] || (_cache[14] = _createTextVNode(" Date de création : ", -1)),
                (_ctx.reception.created_at)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_10, _toDisplayString(_ctx.getDate(_ctx.reception.created_at)), 1))
                  : _createCommentVNode("", true),
                _cache[15] || (_cache[15] = _createTextVNode(" | ", -1)),
                _cache[16] || (_cache[16] = _createElementVNode("b", null, " STOCK ", -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.reception.note_type == 'HC')
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _cache[17] || (_cache[17] = _createTextVNode(" Date de création : ", -1)),
                (_ctx.reception.created_at)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_12, _toDisplayString(_ctx.getDate(_ctx.reception.created_at)), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (Object.keys(_ctx.reception).length != 0 && _ctx.reception.note_saved != 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-outline-success me-3 mb-3",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveReception && _ctx.saveReception(...args)))
              }, _cache[18] || (_cache[18] = [
                _createElementVNode("i", { class: "flaticon-save" }, null, -1),
                _createTextVNode(" Enregister ", -1)
              ])))
            : (
            Object.keys(_ctx.reception).length != 0 && _ctx.reception.note_saved == 1
          )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-outline-success me-3 mb-3",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openReception && _ctx.openReception(...args)))
                }, _cache[19] || (_cache[19] = [
                  _createElementVNode("i", { class: "flaticon-unlock" }, null, -1),
                  _createTextVNode(" Ouvrir ", -1)
                ])))
              : _createCommentVNode("", true)
        ])
      ])
    ]),
    (Object.keys(_ctx.reception).length != 0 && _ctx.reception.note_saved != 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h6", null, "Scan code suivi")
          ], -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchColis && _ctx.searchColis(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[20] || (_cache[20] = _createElementVNode("label", null, "Code Suivi :", -1)),
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "Code Suivi",
                        type: "text",
                        id: "scanFocus",
                        ref: "scaninput",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.codeColis) = $event)),
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.codeColis]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[22] || (_cache[22] = _createElementVNode("button", {
                      style: {"margin-right":"12px"},
                      class: "btn btn-success me-3 mb-3 mt-3",
                      type: "submit"
                    }, [
                      _createElementVNode("i", { class: "ph ph-scan" })
                    ], -1)),
                    _createElementVNode("button", {
                      class: "btn btn-primary me-3 mb-3 mt-3",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.refreshAll && _ctx.refreshAll(...args)))
                    }, _cache[21] || (_cache[21] = [
                      _createElementVNode("i", { class: "ph ph-arrows-clockwise" }, null, -1)
                    ]))
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-12" }, [
                    _createElementVNode("hr")
                  ], -1))
                ])
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_21, [
      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "border-b p-4" }, [
        _createElementVNode("h3", { class: "text-lg font-semibold" }, "Liste des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          (
            _ctx.auth.can('ADD_RECEPTION') &&
            Object.keys(_ctx.reception).length != 0 &&
            _ctx.reception.note_saved != 1
          )
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.removeNewColis && _ctx.removeNewColis(...args)))
              }, _cache[25] || (_cache[25] = [
                _createTextVNode(" Supprimer ", -1),
                _createElementVNode("i", { class: "flaticon-delete position-relative ms-5 fs-12" }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getRows2())),
            onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchTerm) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(_component_vue_good_table, {
          "search-options": { enabled: true, externalQuery: _ctx.searchTerm2 },
          columns: _ctx.columns,
          "row-key": 'id',
          rows: _ctx.rows2,
          responsive: "",
          "select-options": {
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis sélectionées',
        },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => _cache[26] || (_cache[26] = [
            _createElementVNode("div", { class: "text-center py-4 text-gray" }, " Aucune entrées correspondants trouvés ", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_26, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[27] || (_cache[27] = _createElementVNode("i", { class: "icon-repeat" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_27, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[28] || (_cache[28] = _createElementVNode("i", { class: "icon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_28, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'updated_at')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.getDate(props.row.updated_at)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["search-options", "columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.users2,
          offset: 9,
          onPaginate: _ctx.getRows2
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ])
  ], 64))
}